/* FUSFIT velocidad (31-oct-2026). Antes: «Disabled on 2026-04-17: custom deferred home rendering was causing sections
   to blink/hide on refresh» (archivo vacío). Ahora, solo en la portada: las secciones de la 5.ª en adelante llevan
   content-visibility: auto (assets/ff-portada-nueva.css) y el navegador no las maqueta hasta que se acercan. Cuando
   una se hace visible, se avisa a sus carruseles con un «scroll» de mentira para que repinten las flechas
   (cada carrusel ya escucha su propio scroll: bloques, relámpago, Halloween, reseñas). No esconde nada. */
(() => {
  if (!document.body || document.body.dataset.templateName !== 'index') return;
  const RIELES = '.ff-blq__track, .ff-rl__grid, .ff-hwsec__grid, .ff-rg__lista';
  const avisar = (sec) => sec.querySelectorAll(RIELES).forEach((r) => r.dispatchEvent(new Event('scroll')));
  document.querySelectorAll('#MainContent > .shopify-section').forEach((sec) => {
    sec.addEventListener('contentvisibilityautostatechange', (e) => { if (!e.skipped) avisar(sec); });
  });
})();
